// extracted by mini-css-extract-plugin
module.exports = {"selectBox":"style__selectBox___182ST","notAllowed":"style__notAllowed___1k9Ir"};